import { useQuery } from '@apollo/client';
import { Heading, Page, PropertyCard } from '@zillow/constellation-10';
import { GetApplicationsForUserDocument } from '../graphql/queries';
import { ApplicationsList } from '../components/ApplicationsList';

export default function ApplicationsPage() {
  const { loading, data } = useQuery(GetApplicationsForUserDocument, {
    variables: {
      includeSharedApplications: true,
    },
  });

  return (
    <Page.Root css={{ backgroundColor: 'backgroundWhite', minHeight: '100vh' }}>
      <Page.Header>
        <Heading level={1}>Your rental applications</Heading>
      </Page.Header>
      <Page.Content>
        {data && <ApplicationsList data={data} />}
        {loading && !data && <ApplicationsLoading />}
      </Page.Content>
    </Page.Root>
  );
}

function ApplicationsLoading() {
  return (
    <>
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
      <PropertyCard appearance="horizontal" data={{}} loading css={{ maxWidth: '100%', marginBottom: 'default' }} />
    </>
  );
}
